import { render, staticRenderFns } from "./resolution-switch.vue?vue&type=template&id=5a01ca9e&scoped=true&"
import script from "./resolution-switch.vue?vue&type=script&lang=js&"
export * from "./resolution-switch.vue?vue&type=script&lang=js&"
import style0 from "./resolution-switch.vue?vue&type=style&index=0&id=5a01ca9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01ca9e",
  null
  
)

export default component.exports